export default __webpack_public_path__ + "static/media/placeholder_dummy2016-apotheke01-mobile-de.f0d55d06.png";